export default __webpack_public_path__ + "static/media/star-gray.7e4ba603.svg";